import { TextKey } from '@mews-commander/enums';
import { ContentCard } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { WithScope } from '@mews-commander/types';
import { Customer } from '@mews-commander/data-access';
import { ProfileCreateForm } from '../../../../customerProfile/components';
import { useAddCompanionshipsMutation } from '../GroupExistingCustomer/useAddCompanionshipsMutation';

interface GroupAddCustomerProps extends WithScope {
    reservationId: string;
    onSuccess?: () => void;
}

export const GroupAddCustomer = ({ onSuccess, scope, reservationId }: GroupAddCustomerProps) => {
    const enterpriseId = useCurrentEnterpriseId();

    const { mutate, isPending } = useAddCompanionshipsMutation({
        groupId: scope,
        reservationId,
    });

    const onInternalSuccess = (data: Customer) => {
        mutate(
            {
                companionId: data.id,
            },
            {
                onSuccess: () => {
                    if (onSuccess) {
                        onSuccess();
                    }
                },
            }
        );
    };

    return (
        <ContentCard title={<LocalizedText textKey={TextKey.AddNewCustomer} />}>
            <ProfileCreateForm
                form={`customer-add-form-${scope}`}
                enterpriseId={enterpriseId}
                lastName=""
                onSuccess={onInternalSuccess}
                isPending={isPending}
                submitButtonText={TextKey.ReservationGroupCreateCustomerSubmitButton}
                resetFormOnSuccess
                withLoader
                buttonVariant="tertiary"
            />
        </ContentCard>
    );
};
